import React from 'react';

import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import cn from 'classnames';
import i18next from 'i18next';

import st from './shared.module.sass';
import {
  FaceSamplePolicySubForm,
  BodySamplePolicySubForm,
  ImageOriginPolicySubForm,
  EventPolicySubForm,
} from '../../../forms';

function StepStoragePolicies() {
  return (
    <Step
      className={cn(st.Step, st.Step_hollow, st.Step_sparse)}
      title={(
        <StepTitle className={st.StepTitle_separate}>
          {i18next.t('handlers:сохранять данные о лице, теле и атрибутах?')}
        </StepTitle>
      )}
    >
      <FaceSamplePolicySubForm />
      <BodySamplePolicySubForm />
      <ImageOriginPolicySubForm />
      <EventPolicySubForm />
    </Step>
  );
}

StepStoragePolicies.fieldNames = [
  'faceSamplePolicy',
  'eventPolicy',
];

export { StepStoragePolicies };
